import { Add } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { CustomInvoiceListComponent } from "../../components/invoices";
import { PageHeader } from "../../components/v3";
import { PageLayout } from "../../layouts/PageLayout";
import { useHasPermission } from "../../utils";
import { CREATE_CUSTOM_INVOICE } from "../../constants";

export const CustomInvoiceList = () => {
  const navigate = useNavigate();

  const hasCreateInvoice = useHasPermission(CREATE_CUSTOM_INVOICE);

  const handleAddClick = () => {
    navigate("/invoices/create");
  };

  const buttons = [
    hasCreateInvoice && {
      buttonText: "Create Invoice",
      buttonIcon: Add,
      onClick: handleAddClick,
    },
  ];
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title="Invoices" buttons={buttons} />
      </Box>

      <Box sx={{ mt: -9, position: "relative", zIndex: 2 }}>
        <CustomInvoiceListComponent />
      </Box>
    </PageLayout>
  );
};
